import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'parseServerConstant'})
export class ParseServerConstantPipe implements PipeTransform {
    transform(value: string): string {
        return value && value.length > 0  ? (value.charAt(0) +  value.slice(1).toLowerCase().replace(/_/g, ' ')) : '';
    }
}